import { FC } from "react";

import __ from "web/Layout/Translations";

import {
  CodeItemStatusCode,
  CodeItemStatusLabel,
} from "web/hooks/useCodeItemStatus/useCodeItemStatus";

import formatDate from "web/utils/data/parser/dateAndTime/formatDate";
import getDateTime from "web/utils/data/parser/dateAndTime/getDateTime";

import type { PropsWithClasses } from "web/types/Common";

import classify from "web/classify";

import defaultClasses from "./productExpires.scss";

interface IProductExpiresProps {
  date?: string;
  dataT1?: string;
  statusCode?: CodeItemStatusCode;
  label?: CodeItemStatusLabel;
}

const labeledStatuses = [
  CodeItemStatusCode.CANCELED,
  CodeItemStatusCode.WAITING_FOR_PAYMENT,
  CodeItemStatusCode.WAITING,
  CodeItemStatusCode.TO_WITHDRAW,
  CodeItemStatusCode.WITHDRAWING,
  CodeItemStatusCode.WITHDRAWN,
  CodeItemStatusCode.WITHDRAW_ERROR,
];

const ProductExpires: FC<PropsWithClasses<IProductExpiresProps>> = ({
  date,
  classes = {},
  dataT1 = "product_expires",
  statusCode,
  label,
}) => {
  const dateMilliseconds = date ? Date.parse(date) : null;

  // USED
  if (statusCode === CodeItemStatusCode.USED) {
    return null;
  }

  if (labeledStatuses.includes(statusCode as CodeItemStatusCode)) {
    return <div className={classes.root}>{label}</div>;
  }

  if (!dateMilliseconds) {
    return null;
  }

  // AVAILABLE / EXPIRED
  const isExpired = statusCode === CodeItemStatusCode.EXPIRED;
  const isAvailable = statusCode === CodeItemStatusCode.AVAILABLE;
  const rootClassName = [classes.root, isAvailable && classes.available]
    .filter(Boolean)
    .join(" ");
  let prefix = __("Oferta ważna do");
  if (isExpired) {
    prefix = __("Kod wygasł");
  } else if (isAvailable) {
    prefix = __("Kod ważny do");
  }

  return (
    <div className={rootClassName} data-t1={`${dataT1}_label`}>
      {prefix}
      {": "}
      <time
        className={classes.value}
        data-t1={`${dataT1}_date`}
        data-t2={formatDate(dateMilliseconds)}
        dateTime={getDateTime(dateMilliseconds)}
      >
        {formatDate(dateMilliseconds)}
      </time>
    </div>
  );
};

export default classify<PropsWithClasses<IProductExpiresProps>>(defaultClasses)(
  ProductExpires
);
